// Set to false to reopen subscriptions: the suspension notice goes away and the form is enabled again.
export const IS_SUBSCRIPTION_SUSPENDED = true;
